$(function(){
    var bookURL = $('ul#menu-main-navigation li.cta a').attr("href");
  
    $('.mob-tickets-btn').html('<a href="' + bookURL +'"></a>');
})


// WEBPACK FOOTER //
// ./scripts/partials/_mob-link.js